import dayjs from 'dayjs';
import 'dayjs/locale/de-at';

dayjs.locale('de-at');

export const makeDateModel = dayjs;
